import { render, staticRenderFns } from "./MenusPublishSync.vue?vue&type=template&id=855da544&"
import script from "./MenusPublishSync.vue?vue&type=script&lang=js&"
export * from "./MenusPublishSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports